var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "open-salud-about-mindfulness",
      attrs: { id: "mindfulness-main" }
    },
    [
      _c(
        "v-row",
        { staticClass: "row container-assistance" },
        [
          _c(
            "v-col",
            {
              staticClass: "main-container-text px-lg-16 my-auto",
              attrs: { sm: "6" }
            },
            [
              _c("h3", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
              _vm._v(" "),
              _c("h5", { staticClass: "subtitle" }, [
                _vm._v(_vm._s(_vm.subtitle))
              ]),
              _vm._v(" "),
              _c("h7", { staticClass: "thirdtitle" }, [
                _vm._v(_vm._s(_vm.thirdtitle))
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                { staticClass: "pl-0", attrs: { sm: "12" } },
                [
                  _c(
                    "v-row",
                    { staticClass: "mt-3 button-floating" },
                    [
                      _c(
                        "base-button",
                        {
                          staticClass: "btn1",
                          attrs: { white: "", shadow: "" },
                          on: {
                            click: function($event) {
                              return _vm.getWellness()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.button_text2) +
                              "\n          "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("v-col", {
            staticClass: "col-img d-flex flex-row justify-center col-image",
            attrs: { sm: "6" }
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.$store.getters["session/isLogged"]
        ? _c(
            "div",
            {
              staticClass: "learn-more",
              on: {
                click: function($event) {
                  return _vm.$helpers.goToSection("primesalud-price-cards")
                }
              }
            },
            [_c("span", [_vm._v(_vm._s(_vm.$t("learn-more-btn")))])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ec341d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ec341d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/MindfulnessMainBlock.vue
// module id = 4258
// module chunks = 37